import { render, staticRenderFns } from "./DiscardChanges.vue?vue&type=template&id=c3211542&"
import script from "./DiscardChanges.vue?vue&type=script&lang=js&"
export * from "./DiscardChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports